


















































































































































































































































































































































































import Vue from 'vue';
export default Vue.extend({
  name: 'MaterialHelpModal',
  props: {
    domain: String,
  },
});
